import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
  state: () => {
    return {
      breadcrumbs: [],
      appTitle: 'OTP Middleware',
      urlParams: {},
      latitude: 33.8726,
      longitude: 35.5106,
    };
  },
  getters: {
    getBreadcrumbs() {
      return this.breadcrumbs;
    },
    getUpdateUrlParams() {
      return this.urlParams;
    },
    getAppTitle() {
      return this.appTitle;
    },
    getLatitude() {
      return this.latitude;
    },
    getLongitude() {
      return this.longitude;
    },
  },
  actions: {
    setBreadcrumbs(breadcrumbs) {
      this.breadcrumbs = breadcrumbs;
    },
    setAppTitle(show) {
      this.appTitle = show;
    },
    setUpdateUrlParams(params) {
      this.urlParams = params;
    },
  },
});
